import React from 'react';
import { TemplateWithTitle } from 'pages';

interface Props {
    children: React.ReactNode;
}

function Template({ children }: Props): React.ReactElement {
    return <TemplateWithTitle isBackBtn={true}>{children}</TemplateWithTitle>;
}

export default Template;
